// extracted by mini-css-extract-plugin
export default {"container":"container-TMPNy","title":"title-keQ9T","icon":"icon-d5gkM","body":"body-yQOlx"};